import { render, staticRenderFns } from "./resaleOrder.pug?vue&type=template&id=fe38bc32&scoped=true&lang=pug&"
import script from "./resaleOrder.ts?vue&type=script&lang=ts&"
export * from "./resaleOrder.ts?vue&type=script&lang=ts&"
import style0 from "./resaleOrder.styl?vue&type=style&index=0&id=fe38bc32&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe38bc32",
  null
  
)

export default component.exports